export default cookieValue => {
  return {
    Accept: ['application/json', 'text/plain', '*/*'],
    'Content-Type': 'application/json',
    'X-Requested-By': 'Browser',
    'X-XSRF-TOKEN': cookieValue,
  }
}



// WEBPACK FOOTER //
// ./src/config/fetch/httpHeaders.js